var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gru-table',{attrs:{"resource":'menu',"fields":_vm.fields,"primaryKey":'menuId',"enabledToolbar":true,"enabledDelete":true,"enabledAdd":true,"enabledExcel":false,"enabledPrint":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }